import React, { Fragment, useEffect, useContext, useState } from "react";

/* packages */
import { GlobalProvider } from "../../lib-atomic-context";
import {
  ModuleContainerLg,
  ModulePaddedWrapperLg,
  ModuleFormWrapper,
} from "../../lib-atomic-design-section";
/* packages */

/* container */
import CMSContainer from "../../app-module-cms-container/default";
import AccountProfileContainer from "../../app-module-account-profile-container/default";
/* container */

/* module */
import CMSHomeHeader from "../../app-module-cms-section-home-header/default";
import ProfileUpdateForm from "../form/updateProfile";
import AccountProfileMenu from "../../app-module-account-profile-section-menu/default";
/* module */

const index = (props) => {
  return (
    <GlobalProvider>
      <CMSContainer>
        <CMSHomeHeader {...props} />
      </CMSContainer>

      <ModuleContainerLg>
        <ModulePaddedWrapperLg>
          <AccountProfileContainer.AccountUpdate {...props}>
            <ModuleFormWrapper>
              <ProfileUpdateForm {...props} />
            </ModuleFormWrapper>
          </AccountProfileContainer.AccountUpdate>
        </ModulePaddedWrapperLg>
      </ModuleContainerLg>
    </GlobalProvider>
  );
};

export default index;
